import Current from "../generic/Current"

function CustomerOnSite({
  current,
  loading,
  error,
  mutliple,
  prefix,
}: {
  current?: number
  loading: boolean
  error: string | undefined
  mutliple?: boolean
  prefix: string
}) {
  const title = `${prefix} on site${mutliple ? "s" : ""}`
  return <Current heading={title} current={current} loading={loading} error={error} />
}

export default CustomerOnSite
